import { Outlet } from "react-router-dom";

import { AutoLogoutProvider } from "./contexts/AutoLogoutProvider";
import useAuth from "./hooks/useAuth";

const Layout = () => {
  const { user, logout, isAuthenticated } = useAuth();

  return (
    <AutoLogoutProvider
      timeoutMinutes={user?.TimeOut || 10}
      onLogout={logout}
      isEnabled={Boolean(user && isAuthenticated)}
    >
      <main className="App">
        <Outlet />
      </main>
    </AutoLogoutProvider>
  );
};

export default Layout;
